<div class="header">
  <div class="title">Update Custom Select Field</div>
  <div>
    <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
      <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
  </div>
</div>
<form
  [formGroup]="updateCustomFieldForm"
  (submit)="updateCustomFieldForm.pristine || updateCustomFieldForm.invalid ? null : save()"
>
  <div>
    <sortable-dropdown-editor
      [title]="this.updateCustomFieldForm?.value.label"
      [options]="this.updateCustomFieldForm?.value.options"
      showColor="true"
      (onDelete)="onDelete($event)"
      (onAdd)="onAdd($event)"
    ></sortable-dropdown-editor>
  </div>
</form>
